/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetComponentContextResponseDto } from './AssetComponentContextResponseDto';
import {
    AssetComponentContextResponseDtoFromJSON,
    AssetComponentContextResponseDtoFromJSONTyped,
    AssetComponentContextResponseDtoToJSON,
    AssetComponentContextResponseDtoToJSONTyped,
} from './AssetComponentContextResponseDto';

/**
 * 
 * @export
 * @interface ListAssetComponentContextsResponseDto
 */
export interface ListAssetComponentContextsResponseDto {
    /**
     * 
     * @type {Array<AssetComponentContextResponseDto>}
     * @memberof ListAssetComponentContextsResponseDto
     */
    data: Array<AssetComponentContextResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof ListAssetComponentContextsResponseDto
     */
    total: number;
}

/**
 * Check if a given object implements the ListAssetComponentContextsResponseDto interface.
 */
export function instanceOfListAssetComponentContextsResponseDto(value: object): value is ListAssetComponentContextsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function ListAssetComponentContextsResponseDtoFromJSON(json: any): ListAssetComponentContextsResponseDto {
    return ListAssetComponentContextsResponseDtoFromJSONTyped(json, false);
}

export function ListAssetComponentContextsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAssetComponentContextsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(AssetComponentContextResponseDtoFromJSON)),
        'total': json['total'],
    };
}

export function ListAssetComponentContextsResponseDtoToJSON(json: any): ListAssetComponentContextsResponseDto {
    return ListAssetComponentContextsResponseDtoToJSONTyped(json, false);
}

export function ListAssetComponentContextsResponseDtoToJSONTyped(value?: ListAssetComponentContextsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(AssetComponentContextResponseDtoToJSON)),
        'total': value['total'],
    };
}

